import React from 'react';

export default function VideoWrapper(props) {
  const { visible, children, className } = props;

  if (visible === false || !children ) {
    return null;
  }

  const currentClassName = ["VideoWrapper"].concat([className]).join(" ");

  return (
    <div className={currentClassName}>
      { children }
    </div>
  );
}